export const numberWithSpaces = (x: number): string =>
    addCharEvery3Digits(x, ' ');

const addCharEvery3Digits = (x: number, c: string): string =>
    x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, c);

export const replaceCharactersInGivenRange = (
    stringValue: string,
    characterToReplaceWith: string,
    startIndex: number,
    endIndex: number
): string =>
    Array.from(stringValue)
        .map((element, index) =>
            index >= startIndex && index <= endIndex
                ? characterToReplaceWith
                : element
        )
        .join('');
